import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBeVhKmk-zxgkqcDg_RLSAVTp7gj2C_m1Y",
  authDomain: "the-running-genie-68f60.firebaseapp.com",
  projectId: "the-running-genie-68f60",
  storageBucket: "the-running-genie-68f60.firebasestorage.app",
  messagingSenderId: "334944264182",
  appId: "1:334944264182:web:5d188239cd63a8807571d7",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
